module.exports = __webpack_public_path__ + "static/media/registrationloader.df66952e.gif";